/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({ refreshList, notification, selectedDevice, action, handleClose, deviceTypes }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    deviceId: '',
    deviceType: '',
    manufacturerId: '',
    deviceManagerId: '',
    organizationId: '',
    attributes: null,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [organizations, setOrganizations] = useState([]);
  const [attributes, setAttributes] = useState();
  const [selectedDeviceType, selectDeviceTYpe] = useState();

  const key = useRef(null);
  const value = useRef(null);

  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getOrganizations] = useApi();
  const [state2, getDataForUpdate] = useApi();
  const [state3, updateData] = useApi();

  const options_model = [
    { id: 1, value: 'FTL1', label: 'FTL1' },
    { id: 2, value: 'FAT-100', label: 'FAT-100' },
    { id: 3, value: 'SST-100', label: 'SST-100' },
    { id: 4, value: 'SMM-300', label: 'SMM-300' },
    { id: 5, value: 'SAM500', label: 'SAM500' },
    { id: 6, value: 'GL100', label: 'GL100' },
  ];
  const options_revision = [
    { id: 1, value: '1.9.1', label: '1.9.1' },
    { id: 2, value: '1.9.0', label: '1.9.0' },
    { id: 3, value: '1.8.0', label: '1.8.0' },
    { id: 4, value: '1.7.0', label: '1.7.0' },
    { id: 5, value: '1.5.x', label: '1.5.x' },
  ];

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/device/${selectedDevice}`, 'GET');
    } else {
      setFormData({ ...formModel });
    }
  }, [action]);

  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data) {
      if (state2.data.status === 'SUCCESS') {
        setFormData({
          ...state2.data.device,
          deviceType: state2.data.device.deviceType,
          deviceId: state2.data.device.id,
          manufacturerId: getOrgName(state2.data.device.manufacturerId),
          deviceManagerId: getOrgName(state2.data.device.deviceManagerId),
          organizationId: getOrgName(state2.data.device.organizationId),
          attributes: state2.data.device.attributes,
        });
        // setAttributes(state2.data.device.attributes);
        typeof state2.data.device.attributes === 'string'
          ? setAttributes(JSON.parse(state2.data.device.attributes.replace(/'/g, '"')))
          : setAttributes(state2.data.device.attributes);

        selectDeviceTYpe(deviceTypes.find((deviceType) => deviceType.slug === state2.data.device.deviceType));
      }
    }
    if (state2.isError) {
      notification('error', 'Unable to fetch device detail');
    }
  }, [state2, organizations, deviceTypes]);

  useEffect(() => {
    getOrganizations('/organizations', 'GET');
  }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setOrganizations(state.data.organization);
    }
    if (state.isError) {
      notification('error', 'Unable to fetch Organizations');
    }
  }, [state]);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const getId = (name) => {
    const org = organizations.filter((item) => item.organizationName === name);
    return org[0]?.id;
  };

  const getOrgName = (id) => {
    const org = organizations.filter((item) => item.id === id);
    return org[0]?.organizationName;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === 'create') {
      const body = {
        ...formData,
        manufacturerId: getId(formData.manufacturerId),
        deviceManagerId: getId(formData.deviceManagerId),
        organizationId: getId(formData.organizationId),
        attributes,
      };
      postData('/device', 'POST', body);
    } else {
      const body = {
        ...formData,
        id: formData.deviceId,
        manufacturerId: getId(formData.manufacturerId),
        deviceManagerId: getId(formData.deviceManagerId),
        organizationId: getId(formData.organizationId),
        attributes,
      };
      updateData(`/device/${selectedDevice}`, 'PATCH', body);
    }
  };

  useEffect(() => {
    if (state3.data !== null) {
      refreshList();
      notification('success', 'Device details updated successfully');
      handleClose();
    }

    if (state3.isError) {
      notification('error', 'Unable to update device details');
    }
    // if (!state3.isLoading && !state3.isError) {
    //   refreshList();
    // }
  }, [state3]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', 'Device Created Successfully');
      refreshList();
      handleClose();
    }

    if (isError) {
      notification('error', 'Unable to create device');
    }
  }, [isLoading, isError, data]);

  const handleAddAttributes = () => {
    const x = { ...attributes };
    const k = key.current.value;
    const v = value.current.value;
    x[k] = v;
    setAttributes(x);
  };

  useEffect(() => {
    key.current.value = '';
    value.current.value = '';
  }, [attributes]);

  const deleteAttribute = (item) => {
    const attr = { ...attributes };
    delete attr[item[0]];

    setAttributes(attr);
  };

  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className={`bg-white w-full sm:w-2/4 relative top-${action === 'create' ? 0 : 8} rounded-2xl`}>
        <div className="flex justify-between border-b p-6">
          <p className="font-bold text-sm text-textBlue1">{action === 'create' ? 'New' : 'Edit'} Device</p>
          <img src="assets/img/Close.svg" className="h-3 cursor-pointer" alt="" onClick={handleClose} />
        </div>
        <div className="mt-6 flex flex-wrap  gap-y-2 justify-around px-4">
          {deviceTypes.map((deviceType) => (
            <div>
              <button
                className={` focus:outline-none ${
                  formData.deviceType === deviceType?.slug ? `bg-activeIcon border-none text-white` : 'text-parameter'
                }  font-medium text-xs gap-x-1 flex justify-center items-center py-4 px-4 border border-secondary rounded-xl`}
                onClick={() => {
                  setFormData({ ...formData, deviceType: deviceType?.slug });
                  selectDeviceTYpe(deviceType);
                }}
                disabled={action === 'update' && state2?.data?.device?.isActive}
              >
                <img src={deviceType?.logo} className="h-4 sm:mr-2 " alt="" />
                <span className="hidden sm:block">{deviceType?.displayName}</span>
              </button>
            </div>
          ))}
          {/* <div className="w-18">
            <button
              className={` focus:outline-none ${
                formData.deviceType === 'BLE_GW' ? `bg-activeIcon border-none text-white` : 'text-parameter'
              } border border-secondary  font-medium text-base flex justify-center items-center py-4 w-20 sm:w-32 px-4 rounded-xl`}
              onClick={() => {
                setFormData({ ...formData, deviceType: 'BLE_GW' });
              }}
            >
              <img
                src={formData.deviceType === 'BLE_GW' ? 'assets/img/Gateway_white.svg' : 'assets/img/Gateway.svg'}
                className="w-9 sm:mr-2  "
                alt=""
              />
              <span className="hidden sm:block">GATEWAY</span>
            </button>
          </div>
          // <div className="w-1/10" />
          <div className="w-18">
            <button
              className={` focus:outline-none  ${
                formData.deviceType === 'BLE_TAG' ? `bg-activeIcon border-none text-white` : 'text-parameter'
              }  font-medium text-base flex justify-center items-center py-4 w-24 sm:w-32 border border-secondary rounded-xl`}
              onClick={() => {
                setFormData({ ...formData, deviceType: 'BLE_TAG' });
              }}
            >
              <img
                src={formData.deviceType === 'BLE_TAG' ? 'assets/img/BLE_white.svg' : 'assets/img/BLE.svg'}
                className="h-7 sm:mr-3.5  "
                alt=""
              />
              <span className="hidden sm:block">BLE</span>
            </button>
          </div>
          // <div className="w-1/10" /> */}
          {/* <div className="w-16">
            <button
              className={` focus:outline-none ${
                formData.deviceType === 'CATM1_TAG' ? `bg-activeIcon border-none text-white` : 'text-parameter'
              }  font-medium text-base flex justify-center items-center py-4 w-20 sm:w-32 px-4 border border-secondary rounded-xl`}
              onClick={() => {
                setFormData({ ...formData, deviceType: 'CATM1_TAG' });
              }}
            >
              <img
                src={formData.deviceType === 'CATM1_TAG' ? '/assets/img/CATM1_white.svg' : '/assets/img/CATM1.svg'}
                className="h-7 sm:mr-2 "
                alt=""
              />
              <span className="hidden sm:block">CatM1</span>
            </button>
          </div>
          // <div className="w-1/10" />
          <div className="w-18">
            <button
              className={` focus:outline-none ${
                formData.deviceType === 'PRINTER' ? `bg-activeIcon border-none text-white` : 'text-parameter'
              }  font-medium text-base flex justify-center items-center py-4 w-20 sm:w-32  border border-secondary rounded-xl`}
              onClick={() => {
                setFormData({ ...formData, deviceType: 'PRINTER' });
              }}
            >
              <img
                src={formData.deviceType === 'PRINTER' ? '/assets/img/Printer_white.svg' : '/assets/img/Printer.svg'}
                className="h-7 sm:mr-2 "
                alt=""
              />
              <span className="hidden sm:block">PRINTER</span>
            </button>
          </div>
          // <div className="w-1/10" />
          <div className="w-16">
            <button
              className={` focus:outline-none ${
                formData.deviceType === 'NFC_TAG' ? `bg-activeIcon border-none text-white` : 'text-parameter'
              } border border-secondary  font-medium text-base flex justify-center items-center py-4 w-20 sm:w-28 rounded-xl`}
              onClick={() => {
                setFormData({ ...formData, deviceType: 'NFC_TAG' });
              }}
            >
              <img
                src={formData.deviceType === 'NFC_TAG' ? 'assets/img/NFC_White.svg' : 'assets/img/NFC.svg'}
                className="h-7 sm:mr-3.5 "
                alt=""
              />
              <span className="hidden sm:block">NFC</span>
            </button>
          </div> */}
        </div>

        <form className="mt-2 grid grid-cols-2 px-5 gap-x-10" onSubmit={handleSubmit}>
          <div className="mt-4 w-full relative">
            {/* <label htmlFor="company" className="block text-parameter w-1/3 text-sm mr-2">
            DEVICE ID
          </label> */}
            <input
              placeholder="Device Id"
              type="text"
              disabled={action === 'update' && state2?.data?.device?.isActive}
              value={formData.deviceId}
              name="deviceId"
              className="inputLabelText px-4 py-2 focus:outline-none"
              style={{ background: action === 'update' && state2?.data?.device?.isActive ? '#f2f2f2' : '' }}
              onChange={handleInputChange}
            />
          </div>
          {/* <div className="w-1/10" /> */}
          <div className="mt-4 w-full relative">
            {/* <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
            CUSTOMER
          </label> */}
            <input
              placeholder="Customer"
              type="text"
              disabled={action === 'update' && state2?.data?.device?.isActive}
              name="organizationId"
              value={formData.organizationId}
              className="inputLabelText px-4 py-2 focus:outline-none"
              style={{ background: action === 'update' && state2?.data?.device?.isActive ? '#f2f2f2' : '' }}
              onChange={handleInputChange}
              list="customers"
            />
            <datalist id="customers">
              {organizations.map((item) => (
                <option key={item?.id}>{item?.organizationName}</option>
              ))}
            </datalist>
          </div>

          <div className="mt-4 w-full relative">
            {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
            MANUFACTURER
          </label> */}
            <input
              placeholder="Manufacturer"
              type="text"
              name="manufacturerId"
              disabled={action === 'update' && state2?.data?.device?.isActive}
              list="manufacturer"
              value={formData.manufacturerId}
              className="inputLabelText px-4 py-2 focus:outline-none"
              style={{ background: action === 'update' && state2?.data?.device?.isActive ? '#f2f2f2' : '' }}
              onChange={handleInputChange}
            />
            <datalist id="manufacturer">
              {organizations.map((item) => (
                <option key={item?.id}>{item?.organizationName}</option>
              ))}
            </datalist>
          </div>
          {/* <div className="w-1/10" /> */}
          <div className="mt-4 w-full relative">
            {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
            DEVICE MANAGER
          </label> */}
            <input
              placeholder="Device Manager"
              type="text"
              list="device_manager"
              disabled={action === 'update' && state2?.data?.device?.isActive}
              name="deviceManagerId"
              value={formData.deviceManagerId}
              className="inputLabelText px-4 py-2 focus:outline-none"
              style={{ background: action === 'update' && state2?.data?.device?.isActive ? '#f2f2f2' : '' }}
              onChange={handleInputChange}
            />
            <datalist id="device_manager">
              {organizations.map((item) => (
                <option key={item?.id}>{item?.organizationName}</option>
              ))}
            </datalist>
          </div>

          {selectedDeviceType?.attributes?.model && (
            <div className="mt-4 w-full relative">
              {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
            DEVICE MANAGER
          </label> */}
              {action === 'create' ? (
                <input
                  placeholder="Model"
                  type="text"
                  list="model"
                  name="model"
                  required
                  value={formData.options_model}
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    setAttributes({ ...attributes, [event.target.name]: event.target.value });
                  }}
                />
              ) : (
                <input
                  placeholder="Model"
                  type="text"
                  list="model"
                  name="model"
                  value={attributes?.model || ''}
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    setAttributes({ ...attributes, [event.target.name]: event.target.value });
                  }}
                />
              )}
              <datalist id="model">
                {options_model.map((item) => (
                  <option key={item.id} value={item.value} label={item.label} />
                ))}
              </datalist>
            </div>
          )}
          {/* <div className="w-1/10" /> */}
          {selectedDeviceType?.attributes?.revision && (
            <div className="mt-4 w-full relative">
              {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
            DEVICE MANAGER
          </label> */}
              {action === 'create' ? (
                <input
                  placeholder="Revision"
                  type="text"
                  list="revision"
                  name="revision"
                  required
                  value={formData.options_revision}
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    setAttributes({ ...attributes, [event.target.name]: event.target.value });
                  }}
                />
              ) : (
                <input
                  placeholder="Revision"
                  type="text"
                  list="revision"
                  name="revision"
                  value={attributes?.revision || ''}
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    setAttributes({ ...attributes, [event.target.name]: event.target.value });
                  }}
                />
              )}
              <datalist id="revision">
                {options_revision.map((item) => (
                  <option key={item.id} value={item.value} label={item.label} />
                ))}
              </datalist>
            </div>
          )}
          {selectedDeviceType?.attributes?.lot && (
            <div className="mt-4 w-full relative">
              {/* <label htmlFor="company" className="block text-parameter w-1/3 text-sm mr-2">
            DEVICE ID
          </label> */}
              {action === 'create' ? (
                <input
                  placeholder="Lot"
                  type="text"
                  value={formData.lot}
                  name="lot"
                  required
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
                    if (event.target.value.match(alphanumericRegex)) {
                      handleInputChange(event);
                      setAttributes({ ...attributes, [event.target.name]: event.target.value });
                    }
                  }}
                />
              ) : (
                <input
                  placeholder="Lot"
                  type="text"
                  value={attributes?.lot || ''}
                  name="lot"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
                    if (event.target.value.match(alphanumericRegex)) {
                      handleInputChange(event);
                      setAttributes({ ...attributes, [event.target.name]: event.target.value });
                    }
                  }}
                />
              )}
            </div>
          )}
          {/* <div className="w-1/10" /> */}
          {selectedDeviceType?.attributes?.term && (
            <div className="mt-4 w-full relative">
              {/* <label htmlFor="company" className="block text-parameter w-1/3 text-sm mr-2">
            DEVICE ID
          </label> */}
              {action === 'create' ? (
                <input
                  placeholder="Term"
                  type="text"
                  value={formData.term}
                  name="term"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  required
                  onChange={(event) => {
                    const integerRegex = /^[0-9]+$/;
                    if (event.target.value.match(integerRegex)) {
                      setAttributes({ ...attributes, [event.target.name]: event.target.value });
                    }
                  }}
                />
              ) : (
                <input
                  placeholder="Term"
                  type="text"
                  value={attributes?.term || ''}
                  name="term"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={(event) => {
                    const integerRegex = /^[0-9]+$/;
                    if (event.target.value.match(integerRegex)) {
                      setAttributes({ ...attributes, [event.target.name]: event.target.value });
                    }
                  }}
                />
              )}
            </div>
          )}

          <div className="col-span-2 mb-4">
            <p className="font-black text-base my-3 w-full text-primary">ATTRIBUTES</p>

            <div className="relative flex w-full">
              <div className="w-2/5 relative">
                {/* <label htmlFor="website" className="block text-parameter w-1/3 text-sm mr-2">
              KEY
            </label> */}
                <input
                  type="text"
                  placeholder="Key"
                  ref={key}
                  className="inputLabelText px-4 py-2 focus:outline-none"
                />
              </div>
              <div className="w-1/12" />
              <div className="w-2/5 relative">
                {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
              VALUE
            </label> */}
                <input
                  type="text"
                  placeholder="Value"
                  ref={value}
                  className="inputLabelText px-4 py-2 focus:outline-none"
                />
              </div>
              {/* <div className="w-1/10 relative"> */}
              {/* <label htmlFor="city" className="block text-parameter w-1/3 text-sm mr-2">
              VALUE
            </label> */}
              <img
                src="assets/img/Add.svg"
                className="absolute right-0 lg:right-4 h-8 top-1 cursor-pointer"
                alt=""
                onClick={handleAddAttributes}
              />
              {/* </div> */}
            </div>

            <div className="w-full flex gap-x-3 mt-2">
              {attributes &&
                Object.entries(typeof attributes === 'string' ? JSON.parse(attributes.replace(/'/g, '"')) : attributes)
                  .map(([key, value]) => [key, typeof value === 'string' ? value.replace(/^"|"$/g, '') : value])
                  .filter(([key, value]) => value !== '')
                  .map(([key, value]) => (
                    <p
                      key={key}
                      className="text-black py-1 pl-4 pr-8 mt-2 rounded-full border cursor-pointer relative"
                      onClick={() => deleteAttribute([key, value])}
                    >
                      {`${key}: ${value}`}
                      <img
                        src="assets/img/Close.svg"
                        className="absolute top-3 right-2.5 h-2 cursor-pointer "
                        alt=""
                        onClick={() => deleteAttribute([key, value])}
                      />
                    </p>
                  ))}
            </div>

            <div className="w-5/12 ml-auto relative mb-2 mt-6">
              {state2.isLoading || isLoading ? (
                <div className="flex text-xs">
                  <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
                </div>
              ) : (
                <div className="flex text-xs">
                  <button
                    type="submit"
                    onClick={() => handleClose()}
                    className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                    // style={{ border: '1px solid #16406D' }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="rounded-3xl focus:outline-none w-1/2 h-10 text-white bg-btnBg cursor-pointer "
                    style={{ border: '1px solid #16406D' }}
                  >
                    Save
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* <div className="flex w-full items-center justify-center  mt-6 relative">
          {isLoading ? (
            <img src="assets/img/loader.svg" className="w-16 right-36 mx-auto" alt="" />
          ) : (
            <input
              type="submit"
              className="rounded-lg focus:outline-none px-12 h-10 text-textBlue1 cursor-pointer"
              style={{ background: '#16406D33', border: '1px solid #16406D' }}
            />
          )}
        </div> */}
        </form>
      </div>
    </div>
  );
}

export default index;
